export default __webpack_public_path__ + "static/1376-b05c6d366d24dca41c0603da8cf791c1.gif";